function formatIntegerWithCommas(number) {
    const numString = number.toString();
    let formattedIntegerPart = '';
    let integerLength = numString.length;
  
    for (let i = 0; i < integerLength; i++) {
      formattedIntegerPart = numString[integerLength - 1 - i] + formattedIntegerPart;
      if ((i + 1) % 3 === 0 && i + 1 !== integerLength) {
        formattedIntegerPart = ' ' + formattedIntegerPart;
      }
    }
  
    return formattedIntegerPart;
  }

  function formatNumberWithCommas(number, decimalPlaces = -1) {
    let roundedNumber = parseFloat(number);
    if (decimalPlaces >= 0) {
      roundedNumber = Number(roundedNumber.toFixed(decimalPlaces)); // Round the number
    }
  
    const numString = roundedNumber.toString();
    const [integerPart, decimalPart] = numString.split('.');
    let formattedIntegerPart = '';
    let integerLength = integerPart.length;
  
    for (let i = 0; i < integerLength; i++) {
      formattedIntegerPart = integerPart[integerLength - 1 - i] + formattedIntegerPart;
      if ((i + 1) % 3 === 0 && i + 1 !== integerLength) {
        formattedIntegerPart = ' ' + formattedIntegerPart;
      }
    }
  
    let formattedNumber = formattedIntegerPart;
    if (decimalPlaces >= 0 && decimalPart) {
      formattedNumber += '.' + (decimalPart.length > decimalPlaces ? decimalPart.substring(0, decimalPlaces) : decimalPart);
    } else if (decimalPart) {
      formattedNumber += '.' + decimalPart;
    }
  
    return formattedNumber;
  }
  

export {formatIntegerWithCommas, formatNumberWithCommas} ;